import { useMutation } from '@tanstack/react-query';

import { useRootDocumentOrFail } from '../../../../hooks';
import { useEventHandler } from '../../../../hooks/useEventHandler';
import { Workflow } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getWorkflow } from '../../requests/getWorkflow';

export const useFetchWorkflow = (documentDefinition: string) => {
  const rootDocument = useRootDocumentOrFail();
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({ workflowName }: { workflowName: string }) =>
      getWorkflow(
        constructGet,
        { definition: documentDefinition, workflow: workflowName },
        rootDocument.id,
        workflowName,
      ),
  });

  const fetchWorkflow = useEventHandler(
    async (workflowName: string): Promise<Workflow> => {
      const data = await mutateAsync({ workflowName });
      if (data?.data) return data.data;
      throw new Error(
        `Failed to get workflow '${workflowName}': workflow is missing.`,
      );
    },
  );

  return { fetchWorkflow, ...rest };
};
